module.exports = __webpack_public_path__ + "media/shuju.b67ff06f.mp3";